export default (no, currency) => {
    const number = parseFloat(no)
    if (isNaN(number)) {
        return no
    }
    let locale = ''
    currency = currency || 'GBP'
    // prettier-ignore
    switch (currency) {
        case 'GBP':
            locale = 'en-GB'
            break
        case 'USD':
            locale = 'en-US'
            break
        case 'EUR':
            locale = 'en-IE'
            break
        default:
            locale = 'en-GB'
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    }).format(number)
}
